export default __webpack_public_path__ + "static/covid-care-service-webinar-img-d65ea739f13027b5fae8af5209f716a8.png";